import { Suspense, lazy } from 'react';
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Loading from '@/components/Loading';

// 懒加载路由组件
const Index = lazy(() => import('@/pages/Index'));
const AIGeneration = lazy(() => import('@/pages/AIGeneration'));
const Templates = lazy(() => import('@/pages/Templates').then(module => ({ default: module.Templates })));
const Pricing = lazy(() => import('@/pages/Pricing'));
const RiskScan = lazy(() => import('@/pages/RiskScan'));
const Privacy = lazy(() => import('@/pages/Privacy'));
const Terms = lazy(() => import('@/pages/Terms'));
const Disclaimer = lazy(() => import('@/pages/Disclaimer'));
const About = lazy(() => import('@/pages/About'));
const WhyUs = lazy(() => import('@/pages/WhyUs'));
const LegalHub = lazy(() => import('@/pages/LegalHub'));
const LegalHubArticle = lazy(() => import('@/pages/LegalHubArticle'));
const NotFound = lazy(() => import('@/pages/NotFound'));
const Generate = lazy(() => import('@/pages/Generate'));

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Suspense fallback={<Loading />}>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/ai-generation" element={<AIGeneration />} />
                <Route path="/templates" element={<Templates />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/risk-scan" element={<RiskScan />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/disclaimer" element={<Disclaimer />} />
                <Route path="/about" element={<About />} />
                <Route path="/why-us" element={<WhyUs />} />
                <Route path="/legalhub" element={<LegalHub />} />
                <Route path="/legalhub/:slug" element={<LegalHubArticle />} />
                <Route path="/generate/:templateId" element={<Generate />} />
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </BrowserRouter>
        </TooltipProvider>
      </HelmetProvider>
    </QueryClientProvider>
  );
}

export default App;
